export default __webpack_public_path__ + "static/media/other26.1df53ff0.webp";